export type ChannelMessage = {
	event: string;
	data: any;
};

export function isChannelMessageType(msg: any): msg is ChannelMessage {
	return !!msg && typeof msg == 'object' && 'event' in msg && typeof msg.event === 'string' && 'data' in msg;
}
